function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  fill: "#FAFAFA"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask0_937_12379)"
}, React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  fill: "#FDEDEB"
}), React.createElement("path", {
  d: "M13.981 22.9292L19.0007 27.6875V35L13.8783 28.7571C13.2952 28.0464 12.7957 27.271 12.3897 26.4462L11.5424 24.7252C11.2255 24.0815 11.3956 23.3042 11.9525 22.8517C12.5522 22.3645 13.4202 22.3976 13.981 22.9292Z",
  fill: "#FFBF9D"
}), React.createElement("path", {
  d: "M27.4787 44.8284L18.0006 55.5919L20.3265 63.0652C21.2407 66.0025 22.6873 68.7467 24.5941 71.1607V74.8126H40.6657L44.3745 58.6672L39.0173 44.8284H27.4787Z",
  fill: "#FFBF9D"
}), React.createElement("path", {
  d: "M17.1821 15.5944C17.1821 13.9862 17.1821 13.1821 17.5292 12.5679C17.8345 12.0276 18.3216 11.5883 18.9208 11.313C19.602 11 20.4937 11 22.2771 11H40.1094C41.8928 11 42.7845 11 43.4657 11.313C44.0649 11.5883 44.552 12.0276 44.8573 12.5679C45.2044 13.1821 45.2044 13.9862 45.2044 15.5944V54.0728C45.2044 55.681 45.2044 56.4851 44.8573 57.0994C44.552 57.6397 44.0649 58.079 43.4657 58.3543C42.7845 58.6672 41.8928 58.6672 40.1094 58.6672H22.2771C20.4937 58.6672 19.602 58.6672 18.9208 58.3543C18.3216 58.079 17.8345 57.6397 17.5292 57.0994C17.1821 56.4851 17.1821 55.681 17.1821 54.0728V15.5944Z",
  fill: "#263238"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.0112 13.1021C25.0112 12.7903 24.7585 12.5376 24.4468 12.5376H21.3024C19.9369 12.5376 18.8298 13.5485 18.8298 14.7954V54.8717C18.8298 56.1186 19.9369 57.1295 21.3024 57.1295H41.0828C42.4483 57.1295 43.5554 56.1186 43.5554 54.8717V14.7954C43.5554 13.5485 42.4483 12.5376 41.0828 12.5376H38.2207C37.753 12.5376 37.374 12.9167 37.374 13.3843C37.374 13.8519 36.9949 14.231 36.5273 14.231H26.1401C25.5166 14.231 25.0112 13.7255 25.0112 13.1021Z",
  fill: "white"
}), React.createElement("circle", {
  cx: 31.5005,
  cy: 27,
  r: 9,
  fill: "#FF725E"
}), React.createElement("path", {
  d: "M25.5005 27.7306L27.0702 26.1151L30.0984 28.8844L36.0424 23L37.5005 24.615L29.8743 32L25.5005 27.7306Z",
  fill: "white"
}), React.createElement("rect", {
  x: 21.0005,
  y: 40,
  width: 20,
  height: 5,
  rx: 1,
  fill: "black",
  fillOpacity: 0.09
}), React.createElement("rect", {
  x: 21.0005,
  y: 47,
  width: 20,
  height: 5,
  rx: 1,
  fill: "black",
  fillOpacity: 0.09
}), React.createElement("path", {
  d: "M16.7095 41.5383C16.1662 40.9962 15.3788 40.7285 14.5916 40.8183C13.5272 40.9396 12.6706 41.6866 12.4694 42.6691C12.3205 43.3957 12.5539 44.1466 13.0971 44.6886L16.5292 48.1131C16.9354 48.5184 17.4834 48.775 18.0734 48.8361C19.5802 48.9921 20.8766 47.8615 20.811 46.4486C20.7853 45.8953 20.5478 45.3681 20.1415 44.9628L16.7095 41.5383Z",
  fill: "#FFBF9D"
}), React.createElement("path", {
  d: "M17.5337 46.1513C16.9904 45.6093 16.203 45.3416 15.4158 45.4313C14.3514 45.5526 13.4949 46.2997 13.2936 47.2821C13.1447 48.0088 13.3781 48.7596 13.9214 49.3017L17.3534 52.7261C17.7597 53.1315 18.3076 53.388 18.8976 53.4491C20.4044 53.6051 21.7008 52.4745 21.6352 51.0616C21.6095 50.5084 21.372 49.9811 20.9657 49.5758L17.5337 46.1513Z",
  fill: "#FFBF9D"
}), React.createElement("path", {
  d: "M18.3545 35.8256C17.9382 35.153 17.2092 34.7048 16.4001 34.624C15.349 34.5191 14.3618 35.0509 13.9336 35.9524C13.604 36.6464 13.6556 37.4595 14.0719 38.1321L16.5289 42.1019C16.842 42.6077 17.3361 42.9926 17.9178 43.1838C19.3438 43.6524 20.8435 42.8447 21.1214 41.4584C21.2348 40.8928 21.1245 40.3012 20.8115 39.7954L18.3545 35.8256Z",
  fill: "#FFBF9D"
}), React.createElement("path", {
  opacity: 0.4,
  d: "M37.5937 73.7504L36.4669 71.2277C34.5808 67.0052 34.7808 62.1432 37.0073 58.0899C37.7286 56.7768 38.7562 55.6571 40.0028 54.826L44.1052 52.0911L41.3025 74.9037L37.5937 73.7504Z",
  fill: "#63311B"
}), React.createElement("path", {
  d: "M41.715 54.1454L40.802 54.9643C35.1394 60.0434 33.9588 68.4631 38.0062 74.9037H47.0722V67.5998L49.7968 61.3615C50.9819 58.6478 51.4392 55.6722 51.1236 52.7279L49.7124 39.5634C49.617 38.6742 48.8667 38 47.9725 38H47.9364C47.3941 38 46.8851 38.2618 46.5697 38.7031C45.8185 39.7542 45.3515 40.9814 45.2138 42.266L44.1876 51.8389L41.715 54.1454Z",
  fill: "#FFBF9D"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), React.createElement("mask", {
    id: "mask0_937_12379",
    style: {
      "maskType": "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _ref), _ref2);
};

export default __webpack_public_path__ + "static/media/findingDriver.0b8b0cda.svg";
export { SvgComponent as ReactComponent };